module.exports = __webpack_public_path__ + "static/media/parking-slash.c288e171.svg";